// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2eIi7","rootCenter":"LoadMoreObserver_rootCenter__3yVRl","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3x97e"};